import React, { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { useSearchParams} from "react-router-dom";
import {Stack, Button, CircularProgress,Backdrop,Box,MenuItem,Dialog, DialogActions,DialogContent,DialogContentText,DialogTitle, TextField, FormHelperText, Checkbox, FormControlLabel, Select, Radio, RadioGroup, ListItemText, InputLabel } from '@mui/material';
import axios from 'axios';

function Contact() {

  const [searchParams] = useSearchParams();
  let category = searchParams.get("category")

  const [q1SelectedList, setQ1SelectedList] = useState([]);

  let subTitle=""
  let q1Title="";
  let q1List=[]

  switch(category){

    case "service":
        subTitle="サービス・プロダクトに関するお問い合わせ"
        q1Title = "該当するサービス・プロダクトを選択してください（必須）　※複数選択可"
        q1List =[
            "クラウド社労士コモン",
            "給与計算BPO",
            "助成金コーディネート／助成金Sensei",
            "HR Sensei",
            "テレワークコーディネート",
            "社労士業務／労務コンテンツ",
            "その他",
        ]
        break;

    case "partner":
        subTitle="士業パートナーに関するお問い合わせ"
        q1Title = "該当する士業を選択してください（必須）　※複数選択可"
        q1List =[
            "弁護士","公認会計士","税理士","社労士","行政書士","司法書士","中小企業診断士","弁理士","その他"
        ]
        break;

    case "alliance":
        subTitle="業務提携・アライアンスに関するお問い合わせ"
        q1Title = "該当するサービス・プロダクトを選択してください（必須）　※複数選択可"
        q1List =[
          "クラウド社労士コモン",
          "給与計算BPO",
          "助成金コーディネート／助成金Sensei",
          "HR Sensei",
          "テレワークコーディネート",
          "社労士業務／労務コンテンツ",
          "その他",
      ]
        break;

    case "interview":
        subTitle="取材のご依頼に関するお問い合わせ"
        q1Title = "該当する取材テーマを選択してください（必須）　※複数選択可"
        q1List =[
            "TRIPORTのサービス・プロダクトについて",
            "TRIPORTの働き方・労働環境について",
            "TRIPORTの業務改善への取組について",
            "TRIPORTの事業戦略・財務戦略・人材戦略について",
            "TRIPORTの経営者について",
            "TRIPORTの社員について",
            "その他"
        ]
        break;

    case "seminar":
        subTitle="講演会、共催セミナー等のご依頼に関するお問い合わせ"
        q1Title = "該当する講演・セミナーテーマを選択してください（必須）　※複数選択可"
        q1List =[
            "TRIPORTのサービス・プロダクトについて",
            "TRIPORTの働き方・労働環境について",
            "TRIPORTの業務改善への取組について",
            "TRIPORTの事業戦略・財務戦略・人材戦略について",
            "TRIPORTの経営者について",
            "TRIPORTの社員について",
            "その他"
        ]
        break;

    
    case "other":
    default:
        category="other"
        subTitle="その他、お問い合わせ"
      break;

    
  }

  const serverUrl=`https://script.google.com/macros/s/AKfycbxkw81A4MIRiprMzVBXY9AkdbmQUg9y4uKOJ1kgr4yxjSya8lY8flkcLeBTfCwshHL0/exec`
  const VALIDATION_REQUIRED="入力が必須の項目です"
  
  const {
      control,
      handleSubmit,
  } = useForm();
    
  const [isProcessing,setIsProcessing] = useState(false);
  const [dialogInfo,setDialogInfo]=useState(null);
  
  // const [meetingList, setMeetingList]=useState([]);
  const [isCompleted, setIsCompleted]=useState(false);
  

  

  const onSubmit = async(formData)=>{

    try{
        
        // console.log(formData)

        formData.category=category;
        
        setIsProcessing(true)
        
        formData.rm="c9da28f2fc6a4126aad8a45fec601200"
        
        
        
        const response = await axios.post(serverUrl,JSON.stringify(formData));
        
        if(response.status !== 200){
            throw new Error(`request error\n${response.status} ${response.statusText}`);
        }

        const {status, message} = response.data;

        switch(status){
            case "OK":
                setIsCompleted(true);
                
                break;

            
            default:
                throw new Error(message);
        }

    }
    catch(ex){
        showErrorMessage(ex.message)
    }
    finally{
        setIsProcessing(false)
    } 
  }

//   const showInfoMessage = (message)=>{
//     setDialogInfo({
//         title:"Infomation",
//         message:message
//     })
//   }

  const showErrorMessage = (message)=>{
      setDialogInfo({
          title:"Error",
          message:message
      })
  }

  
  return (
   
        
    <Box p={{xs:1, md:5}}>
        <Box maxWidth="1200px" m="0 auto" backgroundColor="white" p={1} borderRadius={1} boxShadow={{md:"rgba(0, 0, 0, 0.5) 2px 2px 8px 0px"}}>
            
          <Box textAlign="center" mt={2} fontWeight="bold" color="rgb(19, 107, 168)">
            <Box component="img" alt="header" width={200} src={`${process.env.PUBLIC_URL}/static/media/logo.png`}/>
            <Box fontSize={{xs:30, md:45}}>お問い合わせフォーム</Box>
            <Box fontSize={{xs:18, md:20}}>- {subTitle} -</Box>
          </Box>

          
          <Box p={5} pr={{xs:0, md:5}} pl={{xs:0, md:5}}>
              
              {isCompleted===false &&
                  <Box component="form" onSubmit={handleSubmit(onSubmit)}>

                    <Box component="fieldset" disabled={isProcessing} border="none">
                      
                      
                      {/* https://zenn.dev/longbridge/articles/640710005e11b1 */}
                      {/* <FormGroup>
                        {q1List.map((item,index)=>{
                            return <FormControlLabel 
                              label={item.label}
                              
                              control={
                                <Controller
                                  key={index}
                                  name={`test.${index}`}
                                  control={control}
                                  
                                  // rules={{
                                  //   required: {value: true, message: VALIDATION_REQUIRED},
                                    
                                  // }}
                                  
                                  render={({field,fieldState})=>
                                    <Checkbox
                                     
                                     {...field} onChange={(e)=>{
                                      const newList =[...q1List]
                                      newList[index].isChecked=e.target.checked
                                      setQ1List(newList)

                                      setError("test",{type:"manual", message: 'このユーザー名はすでに使われています'})
                                      field.onChange(e.target.value)
                                    }} />          
                                  }/>
                              }
                            />
                        })}
                      </FormGroup> */}
                      {q1List.length>0 &&
                      <Controller
                        name={"q1"}
                        control={control}
                        defaultValue=""
                        rules={{
                          required: {value: true, message: VALIDATION_REQUIRED},
                          
                        }}
                        render={({field,fieldState})=>
                          <>
                            <InputLabel sx={{whiteSpace:"normal"}} error={!!fieldState.error?.message}>{q1Title}</InputLabel>
                            {/* <FormHelperText>※複数選択可</FormHelperText> */}
                            <Select
                              // labelId="multiple-checkbox-label"
                              id="multiple-checkbox"
                              {...field}
                              
                              value={q1SelectedList}
                              multiple
                              autoFocus
                              fullWidth
                              error={!!fieldState.error?.message}
                              //  {...field}
                              onChange={(event) => {
                                const {
                                  target: { value },
                                } = event;
                                setQ1SelectedList(
                                  // On autofill we get a stringified value.
                                  typeof value === 'string' ? value.split(',') : value,
                                );
                                field.onChange(value === 'string' ? value.split(',') : value)
                              }}
                              // input={<OutlinedInput label="Tag" />}
                              renderValue={(selected) => selected.join(', ')}
                              
                            >
                              {q1List.map((name,index) => (
                                <MenuItem key={name} value={name} sx={{whiteSpace:"normal"}}>
                                  <Checkbox checked={q1SelectedList.indexOf(name) > -1} />
                                  <ListItemText primary={name} />
                                </MenuItem>
                              ))}
                            </Select>
                            <FormHelperText sx={{ml:1}} error={!!fieldState.error?.message}>{fieldState.error?.message}</FormHelperText>
                          </>          
                        }
                      />
                    }
                      {/* <Controller
                      name="hoge"
                      defaultValue=""
                        rules={{
                          required: {value: true, message: VALIDATION_REQUIRED},
                        }}
                      control={control}
                      render={({field,fieldState})=>{
                        return <FormGroup 
                          {...field}>
                          <FormControlLabel label="1" value="1" control={<Checkbox onChange={()=>{field.onChange("1")}}/>}/>
                          <FormControlLabel label="2"  value="2" control={<Checkbox onChange={()=>{field.onChange("2")}}/>}/>
                        </FormGroup>
                      }}/> */}
                      
                        
                      <Controller
                          name="email"
                          control={control}
                          defaultValue=""
                          rules={{
                            required: {value: true, message: VALIDATION_REQUIRED},
                            pattern:{value:/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,message:'xxx@xxx.xx形式で入力してください'},
                          }}
                          render={({field,fieldState})=>
                            <>
                              <InputLabel sx={{mt:3,whiteSpace:"normal"}} error={!!fieldState.error?.message}>返信用メールアドレス（必須）</InputLabel>
                              <FormHelperText>※記入例）xxx@xxx.co.jp</FormHelperText>
                              <TextField 
                                  {...field}
                                  margin="none"
                                  autoFocus
                                  fullWidth
                                  error={!!fieldState.error?.message}
                                  helperText={fieldState.error?.message}
                                  />
                            </>
                          }
                      />
                      

                      <Controller
                          name="body"
                          control={control}
                          defaultValue={""}
                          rules={{
                              required: {value: true, message: VALIDATION_REQUIRED},
                              maxLength:{value:1000,message:"1000文字以内で入力してください"},
                          }}
                          render={({field,fieldState})=>
                            <>
                              <InputLabel sx={{mt:3,whiteSpace:"normal"}} error={!!fieldState.error?.message}>お問い合わせ内容（必須）</InputLabel>
                              <TextField 
                                  {...field}
                                  
                                  variant="outlined"
                                  margin="none"
                                  multiline
                                  rows={10}
                                  fullWidth
                                  error={!!fieldState.error?.message}
                                  helperText={fieldState.error?.message}
                                  />
                              </>  
                          }
                      />
                      
                      <Controller
                          name="accountName"
                          control={control}
                          defaultValue={""}
                          rules={{
                              required: {value: true, message: VALIDATION_REQUIRED},
                              maxLength:{value:60,message:"60文字以内で入力してください"},
                          }}
                          render={({field,fieldState})=>
                            <>
                              <InputLabel sx={{mt:3,whiteSpace:"normal"}} error={!!fieldState.error?.message}>会社名（必須）</InputLabel>
                              <FormHelperText>※記入例）テスト株式会社</FormHelperText>
                              <TextField 
                                  {...field}
                                  variant="outlined"
                                  margin="none"
                                  fullWidth
                                  error={!!fieldState.error?.message}
                                  helperText={fieldState.error?.message}
                                  />
                              </> 
                          }
                      />
                      

                      <Controller
                          name="customerName"
                          control={control}
                          defaultValue={""}
                          rules={{
                              required: {value: true, message: VALIDATION_REQUIRED},
                              maxLength:{value:60,message:"60文字以内で入力してください"},
                          }}
                          render={({field,fieldState})=>
                            <>
                              <InputLabel sx={{mt:3,whiteSpace:"normal"}} error={!!fieldState.error?.message}>担当者名（必須）</InputLabel>
                              <FormHelperText >※記入例）山田　太郎</FormHelperText>
                              <TextField 
                                  {...field}
                                  variant="outlined"
                                  margin="none"
                                  fullWidth
                                  error={!!fieldState.error?.message}
                                  helperText={fieldState.error?.message}
                                  />
                            </>      
                          }
                      />

                        <Controller
                          name="customerNameKana"
                          control={control}
                          defaultValue={""}
                          rules={{
                              required: {value: true, message: VALIDATION_REQUIRED},
                              maxLength:{value:60,message:"60文字以内で入力してください"},
                          }}
                          render={({field,fieldState})=>
                            <>
                              <InputLabel sx={{mt:3,whiteSpace:"normal"}} error={!!fieldState.error?.message}>担当者名かな（必須）</InputLabel>
                              <FormHelperText >※記入例）やまだ　たろう</FormHelperText>
                              <TextField 
                                  {...field}
                                  variant="outlined"
                                  margin="none"
                                  fullWidth
                                  error={!!fieldState.error?.message}
                                  helperText={fieldState.error?.message}
                                  />
                            </>      
                          }
                      />
                      
                      <Controller
                          name="phone"
                          control={control}
                          defaultValue=""
                          rules={{
                              required: {value: true, message: VALIDATION_REQUIRED},
                              pattern:{value:/^0\d{1,4}[-]?\d{1,4}[-]?\d{4}$/,message:'半角数字で電話番号を入力してください'},
                          }}
                          render={({field,fieldState})=>
                            <>
                              <InputLabel sx={{mt:3,whiteSpace:"normal"}} error={!!fieldState.error?.message}>電話番号（必須）</InputLabel>
                              <FormHelperText>※記入例）03-xxxx-xxxx</FormHelperText>
                              <TextField 
                                  {...field}
                                  variant="outlined"
                                  margin="none"
                                  fullWidth
                                  error={!!fieldState.error?.message}
                                  helperText={fieldState.error?.message}
                                  />
                            </>
                          }
                      />
                      

                      
                      <Controller
                        name="whereknow"
                        control={control}
                        defaultValue=""
                        rules={{
                          required: {value: true, message: VALIDATION_REQUIRED},
                        }}
                        render={({field,fieldState})=>  
                          <>
                            <InputLabel sx={{mt:3,whiteSpace:"normal"}} error={!!fieldState.error?.message}>サービス・プロダクトをどちらでお知りになりましたか？（必須）</InputLabel>
                            <RadioGroup
                              {...field}
                              name={field.name}
                              onChange={(e) => {
                                // const value = parseInt(e.target.value)
                                // if (!isNaN(value)) {
                                //   field.onChange(value)
                                // }
                                field.onChange(e.target.value)
                              }}
                              value={field.value === undefined ? '' : field.value}
                              >
                              {[
                                "インターネットで検索",
                                "インターネット上の記事",
                                "サービス・プロダクトを知っている方からの紹介",
                                "サービス・プロダクトを使っている方からの紹介",
                                "TRIPORTの提携企業様からの紹介",
                                "雑誌・新聞等の記事",
                                "イベント・セミナー等",
                                "TRIPORTのサービス・プロダクトを現在利用している",
                                "TRIPORTのサービス・プロダクトを過去に利用していた",
                                "その他"
                              ].map((item,index)=>{
                                return <FormControlLabel 
                                    key={`${item}`}
                                    value={`${item}`}
                                    label={item}
                                    control={<Radio/>}/>
                                })
                              }
                            </RadioGroup>
                            <FormHelperText sx={{ml:1}} error={!!fieldState.error?.message}>{fieldState.error?.message}</FormHelperText>
                          </>
                        }/>
                      
                      </Box>

                      {/* <Button onClick={()=>{
                        console.log(formState.errors)
                        console.log(formState.hoge)
                        
                      }}>test</Button> */}

                      <Stack mt={5} direction={'column'} spacing={2} justifyContent={"center"} alignItems={"center"}>
                          <Box>個人情報は、<a href="https://triport.co.jp/privacy" target="_blank" rel="noreferrer">プライバシーポリシー</a>に基づき厳重に管理いたします。</Box>
                          <Button type="submit" variant="contained" size="large" sx={{mt:2,p:"20px 40px",fontSize:{xs:18,md:20},fontWeight:"bold"}} disabled={isProcessing }>プライバシーポリシーに同意のうえ送信する</Button>
                      </Stack>
                  </Box>
              }

              {isCompleted===true &&
                  <Box >
                      
                      <Box>お問い合わせいただき、誠にありがとうございました。</Box>
                      
                      <Box mt={2}>内容を確認のうえ、継続的なコンタクトが必要と判断したお問い合わせにつきましては、</Box>
                      <Box>２営業日以内に弊社担当者よりご連絡をさせていただきます。</Box>
                      
                  </Box>
              }
          </Box>
          

          
          
          
          <Backdrop
              sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
              open={isProcessing}>
              <CircularProgress style={{width:"60px",height:"60px"}} />
          </Backdrop>
          
          <Dialog
              fullWidth={true}
              maxWidth={"md"}
              open={dialogInfo != null}
              onClose={() => { setDialogInfo(null); }}>
              <DialogTitle>{dialogInfo?.title}</DialogTitle>
              <DialogContent dividers sx={{overflowWrap:"break-word",whiteSpace:"pre-line"}}>
                  <DialogContentText>{dialogInfo?.message}</DialogContentText>
              </DialogContent>
              <DialogActions>
                  <Button onClick={() => { setDialogInfo(null); }} autoFocus>閉じる</Button>
              </DialogActions>
          </Dialog>


            
        </Box>
        {/* <Box sx={{position:"fixed",bottom:"0",left:"0",right:"0",background:"#454545",color:"white", padding:"5px 0", textAlign: "center"}}>2024 TRIPORT</Box> */}
    </Box>
          
  );
}

export default Contact;
